import { useFrontendContext } from "./use-frontend-context";

export const useLocale = (): string => {
  const frontendContext = useFrontendContext();
  return `${frontendContext.language}-${frontendContext.country}`;
};
